/**
 * Request Interceptors
 * --------------------
 * Intercepts and handles requests to the API.
 *
 * @author  Harvinder Singh <harvinder@maropost.com>
 * @created 2025-09-12
 */


import { useUserStore } from '@/lib/stores'
import { storeToRefs } from 'pinia'

export const AccountIdHandler = (xhrConfig:any) => {
  if ((xhrConfig as any).skipAccountId) {
    return xhrConfig
  }
  try {
    const userStore = useUserStore()
    const { auth } = storeToRefs(userStore)

    xhrConfig.baseURL += `/${auth.value.account.id}`
    return xhrConfig
  } catch (err) {
    console.error('RequestInterceptor::AccountIdHandler::', err)
  }
}

export const TokenHandler = async (xhrConfig:any) => {
  const keycloak  = await import('@/lib/plugins/keycloak-config')
  try {
    // Ensure the token is valid and refresh if needed
    await keycloak.default.updateToken(30) // Refresh if token will expire in 30 seconds
    // Add the token to the Authorization header
    xhrConfig.headers.Authorization = `Bearer ${keycloak.default.token}`
  } catch (error) {
    console.error('Failed to refresh token:', error)
    keycloak.default.login() // Redirect to login if token refresh fails
  }
  return xhrConfig
}

export const MhcTokenHandler = async (xhrConfig:any) => {
  const keycloak  = await import('@/lib/plugins/keycloak-config')
  try {
    // Ensure the token is valid and refresh if needed
    await keycloak.default.updateToken(30) // Refresh if token will expire in 30 seconds
    
    const encodedData = encodeURIComponent(JSON.stringify({
      access_token: keycloak.default.token,
      expires_in: keycloak.default.tokenParsed.exp,
      id_token: keycloak.default.idToken,
      token_type: keycloak.default.tokenParsed.typ
    }));
    // Add the token to the Authorization header
    xhrConfig.headers.kc = encodedData
  } catch (error) {
    console.error('Failed to refresh token:', error)
    keycloak.default.login() // Redirect to login if token refresh fails
  }
  return xhrConfig
}